import { useApolloMutation } from "frontend/utils/apolloApi/useApolloMutation.js";

// gql
import { SET_EDITORIAL_USE_ONLY_ON_UPLOADS } from "frontend/components/fort/mod/photos/gql/mutations";

// utils
import { useApiUploadUpdate } from "frontend/components/fort/mod/photos/hooks/useApiUploadUpdate.js";

// hooks
import { useFetchNonModMutationSynch } from "../../queries/useFetchNonModMutationSynch";

export const useClearEditorialUseOnlyFlag = () => {
    const { fetchNonModMutationSynch } = useFetchNonModMutationSynch();
    const { apiUploadUpdate } = useApiUploadUpdate();

    const { apolloMutate } = useApolloMutation({
        actionDesc: "Uploads: Flags: Editorial Use Only",
        gql: SET_EDITORIAL_USE_ONLY_ON_UPLOADS
    });

    const clearEditorialUseOnlyFlag = async photoUploadIds => {
        const { ssResp } = await apolloMutate({
            variables: {
                photoUploadIds,
                value: false
            }
        });

        apiUploadUpdate(ssResp);

        // Cannot rely on above query to synch all MOD props
        fetchNonModMutationSynch();
    };

    return {
        clearEditorialUseOnlyFlag
    };
};
